export const ModelListBR = [
    {
        'group':'BlueRock',
        'name':'Google',
        'models':
        [
            // {name:'SATELLITEO',url:'./models/satellite2.glb'},
            {name:'SATELLITE',url:'./models/googleLayout.glb'},
        ]   

    },
    {
        'group':'BlueRock',
        'name':'Digitized',
        'models':
        [
            {name:'Surface',url:'./models/surface.glb' },
            {name:'Underground',url:'./models/underground.glb' }
        ]   

    },
    {
        'group':'Holes',
        'name':'Holes',
        'models':
        [          
            {type:'holesassays',name:'Drilling',assay_url:'./files/AssayData.csv' , hole_url:'./files/HoleData.csv'},
            ]   

    }
    
]